<template>
<!--eslint-disable -->
    <div class="module-wrap module-kda" :kdaData="kdaData">
      <h2 v-html="moduleTitle"></h2>
      <div class="tip"><em>KDA指标</em>（K=K.O.Time D=Difficulty A=Accuracy  数值越高表示在该环节中水平越高）</div>
      <div class="kda-bar">
        <div class="strong">
          <p>当前KDA：{{kdaData.user_kda || 0}}</p>
          <!--<p>你击败了全国{{parseInt(kdaData.beat_accuracy*100)}}%的学生!</p>-->
        </div>
        <div>
          <p>总测试人数：{{kdaData.total_people || 0}}</p>
          <p>中位数：{{kdaData.middle_kda || 0}}</p>
          <p>测试最高值：{{kdaData.max_kda || 0}}</p>
          <p>测试平均值：{{kdaData.avg_kda || 0}}</p>
        </div>
      </div>
      <div class="my-bar" id="myBar" style="width: 620px; height: 500px;margin-left: 60px;">
      </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleKDATarget',
  props: ['moduleTitle', 'kdaData'],
  data () {
    return {
      kda_table: [],
      x_kda: '',
      y_kda: '',
      x_kda_data: [],
      y_kda_data: [],
      kda_count: [],
      total_people: '',
      all_peopel: ''
    }
  },
  mounted () {
    this.initData()
  },
  watch:{
    kdaData (val) {
      this.initData()
    }
  },
  methods: {
    initData: async function () {
      let that = this
      let res = await this.kdaData
      if(res && res.kda_table && res.kda_table.length>0){
        let kData = {
          x_kda_data: [],
          y_kda_data: [],
          kda_count: res.kda_count || 0,
          user_kda: res.user_kda || 0
        }
        if(res.kda_table.length>0){
          res.kda_table.forEach(function (v) {
            kData.x_kda_data.push(v.kda)
            kData.y_kda_data.push({value: v.kda_count})
          })
        }
        this.total_people = res.total_people || 0
        this.all_peopel = res.kda_count || 0
        this.renderBar(document.getElementById('myBar'),kData)
      }
    },
    renderBar: function (id, data) {
      var myBar = echarts.init(id)
      var dataIndex=$.inArray(data.user_kda,data.x_kda_data) ;//当前下标
      var averageY=Math.round(350/data.kda_count),//Y每份高度,
        currentPosY=350-averageY*data.y_kda_data[dataIndex].value+60;//Y当前位置
      var option = {
        tooltip: {
          formatter: function(params) {
            console.log(params)
            let tip =  "人:" + params.value + "<br>KDA:" + params.name
            return tip
          }
        },
        calculable : true,
        legend: {
          data:['Growth', '你的位置', 'KDA 0.5'],
          itemGap: 5
        },
        grid: {
          top: '12%',
          left: '3%',
          right: '7%',
          containLabel: true
        },
        xAxis: [
          {
            name : 'KDA',
            type : 'category',
            data : data.x_kda_data || 0
          }
        ],
        yAxis: [
          {
            type : 'value',
            name : '人',
            min: 0,
            max: data.kda_count,
            interval: data.kda_count,
            splitLine: {show: false}
            // axisLabel: {
            //   formatter: function (kda_count) {
            //     return data.kda_count
            //   }
            // }
          }
        ],
        dataZoom: [
          {
            id: 'dataZoomX',
            show: true,
            start: 0,
            end: (dataIndex+1)/data.x_kda_data.length*100
          }
        ],
        series : [
          {
            name: data.y_kda_data[dataIndex].value + '人',
            type: 'bar',
            data: data.y_kda_data,
            barGap: '2%',
            markLine : {
              symbol : 'none',
              silent: true,
              itemStyle : {
                normal : {
                  color:'rgba(102,102,102,.6)',
                  label : {
                    show:true,
                    formatter: function (param) {
                      console.log(param)
                      return param.seriesName;
                    }
                  }
                }
              },
              data : [
                {name:'人' , value:data.user_kda,  yAxis: data.y_kda_data[dataIndex].value}
              ]
            },
            markPoint : {
              symbol: 'pin',
              symbolSize: 60,
              data : [
                {
                  name: '',
                  coord: [dataIndex,data.y_kda_data[dataIndex].value],
                  // y:currentPosY,
                  tooltip: {
                    formatter: function(params) {
                      console.log(params)
                      let tip = '你的位置' + "<br>KDA：" +  [data.user_kda]
                      return tip
                    }
                  }
                }
              ]
            },
            barWidth: '6px',
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0, color: '#ABBDFF' // 0% 处的颜色
                  }, {
                      offset: 1, color: '#7CD7FF' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              },
              emphasis: {
                 color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0, color: '#2378f7' // 0% 处的颜色
                  }, {
                      offset: 1, color: '#83bff6' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }
          }
        ]
      };
      if (option && typeof option === "object") {
        myBar.setOption(option, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.tip{
text-align: center;
  color: #666;
  font-size: 12px;
  em{
    font-style: normal;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #333;
  }
}

.kda-bar{
  width: 600px;
  height: 120px;
  margin: 24px auto;
  padding: 26px 24px;
  background: url("~@/assets/img/KDA_bar_bg.png") no-repeat;
  background-size: cover;
  
  div{
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #666;
  }
  .strong{
    margin-bottom: 27px;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #333;
    letter-spacing: 0;
    line-height: 20px;
  }
}
</style>
